import { yearsSince } from "~/common/utils";
import { getFullName, PatientData } from "~/providers/utils";
import {
  BasicPatientInformation,
  ConsultationExport,
} from "~/providers/utils/types/consultation";
import { PdfPatientInformationCardProps } from "./shared/PdfPatientInformationCard";

export const getPatientNameAndAge = ({
  patient,
  report,
}: ConsultationExport) => {
  const fullName = getFullName(patient.name, patient.last_name);

  const {
    basic_patient_information: { date_of_birth: dateOfBirth },
  } = report;

  const age = yearsSince(dateOfBirth);

  return [fullName, age ? `(${age} years old)` : undefined]
    .filter(Boolean)
    .join(" ");
};

const getNameWithAge = (fullName: string, dateOfBirth?: string) => {
  const age = dateOfBirth ? yearsSince(dateOfBirth) : undefined;

  return [fullName, age ? `(${age} years old)` : undefined]
    .filter(Boolean)
    .join(" ");
};

export const getPdfPatientInformationFromConsultation = ({
  patient,
  report,
}: ConsultationExport): PdfPatientInformationCardProps => {
  const {
    basic_patient_information: {
      date_of_birth: dateOfBirth,
      gender,
      marital_status: maritalStatus,
      occupation,
    },
  } = report;

  return {
    nameWithAge: getPatientNameAndAge({ patient, report }),
    dateOfBirth,
    gender,
    occupation,
    maritalStatus,
  };
};

export const getPdfPatientInformationFromPatient = (
  patient: PatientData,
  basicPatientInformation?: BasicPatientInformation | null,
): PdfPatientInformationCardProps => {
  const dateOfBirth =
    basicPatientInformation?.date_of_birth ?? patient.birthday ?? "";
  const fullName = getFullName(patient.name, patient.last_name);

  return {
    nameWithAge: getNameWithAge(
      fullName,
      basicPatientInformation?.date_of_birth ?? patient.birthday,
    ),
    dateOfBirth,
    gender: basicPatientInformation?.gender ?? "",
    occupation: basicPatientInformation?.occupation ?? "",
    maritalStatus: basicPatientInformation?.marital_status ?? "",
  };
};
